/* eslint-disable parog-web/no-glint-expect-error-directive */
import { hash } from '@ember/helper';
import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import changesetGet from 'ember-changeset/helpers/changeset-get';
import changesetSet from 'ember-changeset/helpers/changeset-set';
import FuiCalendar from 'parog-web/components/fui-calendar';
import FormyComponent from '../formy';
import FormyField from './field';

type Args =
  | { parent: FormyComponent; key: string }
  | {
      parent: FormyField;
      key: never;
    };

interface Signature {
  Args: Args;
  Element: HTMLDivElement;
}

export default class FormyDateComponent extends Component<Signature> {
  get changeset(): EmberChangeset {
    return this.#formy.args.changeset;
  }

  get id(): FormyField['id'] | undefined {
    return this.args.parent instanceof FormyField
      ? this.args.parent.id
      : undefined;
  }

  get key(): string {
    return this.args.parent instanceof FormyField
      ? this.args.parent.args.key
      : this.args.key;
  }

  get #formy(): FormyComponent {
    if (this.args.parent instanceof FormyComponent) return this.args.parent;
    return this.args.parent.args.formy;
  }

  <template>
    <FuiCalendar
      {{! @glint-expect-error }}
      @id={{this.id}}
      @selected={{changesetGet this.changeset this.key}}
      @settings={{hash type='date'}}
      @onFocusOut={{changesetSet this.changeset this.key}}
      ...attributes
    />
  </template>
}
